import AnalyService from "./analytics.service"

export function validCuilNumber( value ) {

   if ( value === undefined ) { return 'Dato requerido!' }
   if ( isNaN( value ) ) { return 'Debe ser un número!' }
   if ( value < 20000000000 ) { return 'Número de CUIL inválido!' }
   if ( value > 40000000000 ) { return 'Número de CUIL inválido!' }
   if ( parseInt( value ) != value ) { return 'Debe ser un número entero!' }
   return true
}

export async function validCuilAffil( value ) {

   let promise = new Promise(( resolve ) => {
      AnalyService.affiliateExists( value )
         .then(response => {
            resolve( response.data )
         })
         .catch(error => {
            console.log(error);
            return 'Error de red!'
         });
   })

   let result = await promise
   if ( result == 'N') {
      return 'No hay ningún Afiliado con este CUIL'
   }
   if ( result == 'I') {
      return 'No es un Afiliado Activo'
   }
   return true
}

export async function findBasicAffilData( value ) {

   let promise = new Promise(( resolve ) => {
      AnalyService.getAffiliateBasicData( value )
         .then(response => {
            resolve( response.data )
         })
         .catch(error => {
            console.log(error);
            return false
         });
   })

   return await promise
}
